export default __webpack_public_path__ + "static/media/news-primary-icon.18ef4403.svg";